<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Work Order Term</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="woTerm.id === null">New</span>
              <span v-else>
                {{ woTerm.name }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="woTerm.name" class="form-control"/>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="category_id" class="col-sm-3 col-form-label text-left">Category</label>
              <div class="col-sm-9">
                <select v-model="woTerm.category_id" class="form-control">
                  <option v-for="o in woTermCategoryList" :key="o.id" :value="o.id">{{ o.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateWoTerm" class="btn btn-sm btn-primary pull-right" v-show="woTerm.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createWoTerm" class="btn btn-sm btn-primary pull-right" v-show="woTerm.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <!-- <pre>
      {{ woTerm }}
    </pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { woTermUrl, getHeader } from '../../config'

export default {
  name: 'WoTermForm',
  props: ['woTerm'],
  computed: {
    ...mapState({
      woTermCategoryList: state => state.woTermCategories.woTermCategoryList
    })
  },
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateWoTerm () {
      axios.put(woTermUrl + '/' + this.woTerm.id, this.woTerm, { headers: getHeader() })
        .then(response => {
          this.$swal('Work Order Term', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createWoTerm () {
      axios.post(woTermUrl, this.woTerm, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
